<template>
  <div>
    <el-row>
      <el-col>
        <el-row :span="24">
          <el-col
            :span="24"
            style="text-align: center;font-size: 50px;color: #fff;;font-weight: bold;padding-top:80px;text-shadow: rgb(0, 0, 0) 5px 2px 6px;"
          >
            {{ title }}
          </el-col>
          <el-col
            :span="18"
            style="margin-left: 30px;text-align: left;font-size: 18px;color: #fff;margin-bottom: 40px;"
          >
          </el-col>
          <el-col :span="14" class="index_bg" :offset="5">
            <el-col :span="11" class="index_bj_content">
              <div>
                <el-col :span="5"
                  ><img
                    src="../../../assets/constractor_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >建设单位</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >单位注册、登录、密码修改、项目报审主体、查看意见、下载报告</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div>
                <el-col :span="5"
                  ><img
                    src="../../../assets/suevey_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >勘察单位</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >单位注册、登录、密码修改、项目报审、回复、下载图纸</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div>
                <el-col :span="5"
                  ><img
                    src="../../../assets/design_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >设计单位</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >单位注册、登录、密码修改、设计项目报审、回复、下载图纸</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div>
                <el-col :span="5"
                  ><img
                    src="../../../assets/examination_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >审图机构</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >项目接审、分配、审查图纸、出具意见、综合统计</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div>
                <el-col :span="5"
                  ><img
                    src="../../../assets/supervice_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >111111</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >项目查询、统计报表、系统配置、质量监督</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <!-- <el-col :span="11" class="index_bj_content">
							<router-link :to="''">
								<el-col :span="5"><img src="../../../assets/user_icon.png" alt="" style="width:44px;margin: 10px 0px;"></el-col>
								<el-col :span="18" style="height: 74px;">
									<el-col :span="24" style="font-weight: bold;font-size: 20px;color: #333;">社会公众</el-col>
								</el-col>
								<span class="triangle"><i class="el-icon-edit"></i></span>
							</router-link>
						</el-col> -->
          </el-col>
          <el-col
            :span="24"
            style="text-align: center;font-size: 30px;color: #fff;position: fixed;bottom: 60px;text-shadow: rgb(0, 0, 0) 5px 2px 6px;"
          >
            技术支持单位：库傲（上海）信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;技术服务热线：021-55883521
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogFormVisible"
      :show-close="false"
      :close-on-click-modal="false"
      style="text-align:left;font-size:20px;border-radius:10px;color:#c9c9c9"
      width="800px"
    >
      <div style="font-size:16px" class="dialogTitle">
        <p style="width:84px;margin:auto">
          <i
            class="el-icon-message-solid"
            style="font-size:80px;text-align:center;color:#90e16d"
          >
          </i>
        </p>
        <p style="font-size:30px;text-align:center;color:#333;margin-top:50px">
          {{ count }}
        </p>
      </div>
      <el-row class="dialogBody">
        <el-col :span="24">
          <div
            style="color:#c9c9c9;font-size:16px;margin-top:4px;text-align:center;margin-bottom:20px"
          >
            系统正在为您检测账户,请耐心等待.....
          </div>
        </el-col>
      </el-row>
      <!-- <el-row class="dialogBody">
        <el-col :span="24">
           <div style="color:#ff8c65;font-size:16px;margin-top:4px;text-align:center;margin-bottom:30px">
			   <el-row>
				    <el-button size="medium" round type="warning" @click="jsLogin">建设单位</el-button>
					<el-button size="medium" round type="warning" @click="sjLogin">设计单位</el-button>
					<el-button size="medium" round type="warning" @click="stLogin">审图机构</el-button>
					<el-button size="medium" round type="warning" @click="lsLogin">联审办</el-button>
			   </el-row>
			    <el-row>
				    <el-button size="medium" round type="text" @click="jsLogin" style="color:#e6a23c;width:98px">張三</el-button>
					<el-button size="medium" round type="text" @click="sjLogin" style="color:#e6a23c;width:98px">里斯</el-button>
					<el-button size="medium" round type="text" @click="stLogin" style="color:#e6a23c;width:98px">王五</el-button>
					<el-button size="medium" round type="text" @click="lsLogin" style="color:#e6a23c;tetx-lign:center;width:98px">赵柳</el-button>
			   </el-row>
		   </div>
        </el-col>
      </el-row> -->
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      bg: "",
      count: "",
      timer: null,
      autoList: [],
      dialogFormVisible: false,
      sysConfig: "/draw/sys/sysconfig",
      url: {
        sysFunctionsIntroduce: "/draw/sysFunctionsIntroduce",
        autoLogin: "/draw/auto/autologin"
      },
      login: {
        username: "88888888",
        password: "88888888",
        // type: '建设单位',
        identifyCode: ""
      }
    };
  },
  created() {
    this.$route.query.ticket;
    // this.mm();
    // var tt = {
    // 	"message": null,
    // 	"result": "{\"orgName\":\"中国置业有限公司(测试)\",\"corpID\":36,\"autoCode\":\"censor\",\"contactPerson\":\"建设单位姓名\",\"contactPersonTel\":\"13918563396\",\"areaCustomerID\":32,\"roleName\":\"manager\",\"status\":200}",
    // 	"status": 200,
    // 	"timestamp": 1574044917520,
    // 	"includes": null,
    // 	"excludes": null
    // }
  },
  mounted() {
    // this.query_config();
    // this.countTime();
    this.queryByLogin();
    document
      .querySelector("body")
      .setAttribute(
        "style",
        "background-image:url(" +
          require("../../../assets/bg-index.png") +
          ");background-size: 100%; background-repeat: no-repeat;"
      );
  },
  methods: {
    // 	mm(){
    //
    // 		 $.ajax({
    // 		type: "get",
    // 		url: '/ticket/yhzx/member/usercenter/fortickethcp.do',
    // 		success: function (res) {
    // 		},
    // 		error:function(res){
    // 		}
    // });
    // 	},
    jsLogin() {
      this.$http
        .post("/censor/login", this.login, { emulateJSON: true })
        .then(res => {
          this.loading = false;
          if (res.data.status == "200") {
            this.$message.success("登录成功，欢迎回来");
            this.$store.commit("$_setStorage", { user: res.body });
            this.$store.commit("$_setLogin", "100");
            this.$store.commit("$_setDraw", "建设单位网上报审");
            this.$router.push("/constructionHome");
          } else {
            this.loading = false;
            this.$message.error(res.body.message);
          }
        });
    },
    sjLogin() {
      this.$http
        .post("/design/login", this.login, { emulateJSON: true })
        .then(res => {
          this.loading = false;
          if (res.data.status == "200") {
            this.$message.success("登录成功，欢迎回来");
            this.$store.commit("$_setStorage", { user: res.body });
            this.$store.commit("$_setLogin", "200");
            this.$store.commit("$_setDraw", "设计网上报审");
            this.$router.push("/designHome");
          } else {
            this.loading = false;
            this.$message.error(res.body.message);
          }
        });
    },
    stLogin() {
      this.login.type = "审查机构";
      if (
        this.login.username.substring(0, 1) === "5" ||
        this.login.username === "13100"
      ) {
        this.$message.error("没有该账号，请确认后重新输入!");
        return;
      }
      this.$http
        .post("/draw/login", this.login, { emulateJSON: true })
        .then(res => {
          this.loading = false;
          if (res.data.status == "200") {
            this.$message.success("登录成功，欢迎回来");
            this.$store.commit("$_setStorage", { user: res.body });
            this.$store.commit("$_setLogin", "300");
            this.$store.commit("$_setDraw", "审图机构");
            this.$router.push("/inspectDrawHome");
          } else {
            this.loading = false;
            this.$message.error(res.body.message);
          }
        });
    },
    lsLogin() {
      this.login.type = "审查机构";
      if (this.login.username.substring(0, 1) != "5") {
        if (this.login.username != "13100") {
          this.$message.error("该用户不存在，请核对后重新登录");
          return;
        }
      }
      this.$http
        .post("/draw/login", this.login, { emulateJSON: true })
        .then(res => {
          this.loading = false;
          if (res.data.status == "200") {
            this.$message.success("登录成功，欢迎回来");
            this.$store.commit("$_setStorage", { user: res.body });
            this.$store.commit("$_setLogin", "300");
            this.$store.commit("$_setDraw", "监管机构");
            this.$router.push("/inspectSuperviseHome/HOME/supervise");
          } else {
            this.loading = false;
            this.$message.error(res.body.message);
          }
        });
    },
    query_config() {
      this.$http
        .get(this.url.sysFunctionsIntroduce + "?code=portal_bg")
        .then(res => {
          document
            .querySelector("body")
            .setAttribute(
              "style",
              " background-image:url(" +
                res.data.result.data[0].url +
                "); background-repeat: no-repeat;"
            );
        });
      this.$http
        .get(this.url.sysFunctionsIntroduce + "?code=portal_title")
        .then(res => {
          this.title = res.data.result.data[0].content;
        });
    },
    countTime() {
      this.queryByLogin();
      const TIME_COUNT = 9;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    queryByLogin() {
      this.$http
        .post(this.url.autoLogin + "/" + this.$route.query.ticket)
        .then(res => {
          if (res.body.status === 200) {
            if (
              res.body.result === "用户名不对" ||
              res.body.result === "该票据不存在或已过期"
            ) {
              // this.dialogFormVisible = false;
              this.$confirm("当前系统检测到无匹配数据，是否注册?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  window.open("http://221.229.211.73:8088/#/");
                  // this.$router.push("/");
                })
                .catch(() => {
                  window.open("http://221.229.211.73:8088/#/");
                });
            } else {
              this.autoList = JSON.parse(res.body.result);
              if (this.autoList.autoCode === "censor") {
                this.autoLogin(this.autoList.autoCode, this.autoList.Ctoken);
              } else if (this.autoList.autoCode === "design") {
                this.autoLogin(this.autoList.autoCode, this.autoList.Ctoken);
              } else if (
                this.autoList.autoCode === "draw" &&
                (this.autoList.roles == 1 ||
                  this.autoList.roles == 2 ||
                  this.autoList.roles == 3 ||
                  this.autoList.roles == 4)
              ) {
                this.$message.success("登录成功，欢迎回来");
                this.$store.commit("$_setStorage", {
                  user: JSON.parse(res.body.result)
                });
                this.$store.commit("$_setLogin", "300");
                this.$store.commit("$_setDraw", "审图机构");
                this.$router.push("/inspectDrawHome");
              } else if (
                this.autoList.autoCode === "draw" &&
                (this.autoList.roles == 0 || this.autoList.roles == 5)
              ) {
                this.$message.success("登录成功，欢迎回来");
                this.$store.commit("$_setStorage", {
                  user: JSON.parse(res.body.result)
                });
                this.$store.commit("$_setLogin", "300");
                this.$store.commit("$_setDraw", "监管机构");
                this.$router.push("/inspectSuperviseHome/HOME/supervise");
              }
            }
          } else {
            this.$message.error("查询失败，请联系管理员");
          }
        });
    },
    autoLogin(code, Ctoken) {
      let URL = "";
      if (code === "censor") {
        URL = "/censor/auto/autologin";
      } else if (code === "design") {
        URL = "/design/auto/autologin";
      }
      this.$http.post(URL + "/" + Ctoken).then(res => {
        if (res.body.status === 200) {
          if (code === "censor") {
            this.$message.success("登录成功，欢迎回来");
            this.$store.commit("$_setStorage", {
              user: JSON.parse(res.body.result)
            });
            this.$store.commit("$_setLogin", "100");
            this.$store.commit("$_setDraw", "建设单位网上报审");
            this.$router.push("/constructionHome");
          } else if (code === "design") {
            this.$message.success("登录成功，欢迎回来");
            this.$store.commit("$_setStorage", {
              user: JSON.parse(res.body.result)
            });
            this.$store.commit("$_setLogin", "200");
            this.$store.commit("$_setDraw", "设计单位网上报审");
            this.$router.push("/designHome");
          }
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../../styles/css/index-cf.css";
@import "../../../styles/css/index-xz";
html,
body {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login/xuzhou/index-xz-jump.vue